package com.wintermar.inspection.core.ui.util.modifier

import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

fun Modifier.borderExceptBottom(
    color: Color,
    width: Dp = 1.dp,
    topWidth: Dp = 1.dp,
    topLeftRadius: Dp = 0.dp,
    topRightRadius: Dp = 0.dp
) = this.drawBehind {
    val strokeWidth = width.toPx()
    val topStrokeWidth = topWidth.toPx()
    val tlRadius = topLeftRadius.toPx()
    val trRadius = topRightRadius.toPx()

    // inset by half the stroke width so the stroke stays fully inside the bounds
    val half = strokeWidth / 2f
    val topHalf = topStrokeWidth / 2f

    // left (starts after top-left arc; no bottom inset since bottom border is absent)
    drawLine(
        color = color,
        start = Offset(half, tlRadius + topHalf),
        end = Offset(half, size.height),
        strokeWidth = strokeWidth
    )
    // right (starts after top-right arc)
    drawLine(
        color = color,
        start = Offset(size.width - half, trRadius + topHalf),
        end = Offset(size.width - half, size.height),
        strokeWidth = strokeWidth
    )
    // top (between the two arcs)
    drawLine(
        color = color,
        start = Offset(tlRadius + half, topHalf),
        end = Offset(size.width - trRadius - half, topHalf),
        strokeWidth = topStrokeWidth
    )
    // top-left arc – rect shifted by (half, topHalf) so its endpoints align with the inset lines
    if (tlRadius > 0f) {
        drawArc(
            color = color,
            startAngle = 180f,
            sweepAngle = 90f,
            useCenter = false,
            topLeft = Offset(half, topHalf),
            size = Size(2 * tlRadius, 2 * tlRadius),
            style = Stroke(width = topStrokeWidth)
        )
    }
    // top-right arc
    if (trRadius > 0f) {
        drawArc(
            color = color,
            startAngle = 270f,
            sweepAngle = 90f,
            useCenter = false,
            topLeft = Offset(size.width - 2 * trRadius - half, topHalf),
            size = Size(2 * trRadius, 2 * trRadius),
            style = Stroke(width = topStrokeWidth)
        )
    }
}
